import { Type } from '../../../redux/Transaction/helper';

const SpecInfo = {
    contactAddresses: [
        Type.sale_quote,
        Type.sale_delivery_order,
        Type.sale_order,
        Type.sale_invoice,
        Type.sale_credit_note,
        Type.sale_payment,
        Type.sale_refund,
        Type.purchase_order,
        Type.purchase_goods_received_note,
        Type.purchase_bill,
        Type.purchase_credit_note,
        Type.purchase_payment,
        Type.purchase_refund,
        Type.bank_income,
        Type.bank_expense,
    ],
    contactPersons: [
        Type.sale_quote,
        Type.sale_delivery_order,
        Type.sale_order,
        Type.sale_invoice,
        Type.sale_credit_note,
        Type.sale_payment,
        Type.sale_refund,
        Type.purchase_order,
        Type.purchase_goods_received_note,
        Type.purchase_bill,
        Type.purchase_credit_note,
        Type.purchase_payment,
        Type.purchase_refund,
        Type.bank_income,
        Type.bank_expense,
    ],
    companyAddresses: [
        Type.purchase_order,
        Type.purchase_goods_received_note,
        Type.purchase_bill,
        Type.purchase_credit_note,
    ],
    emails: [
        Type.sale_quote,
        Type.sale_delivery_order,
        Type.sale_order,
        Type.sale_invoice,
        Type.sale_payment,
        Type.sale_credit_note,
        Type.sale_refund,
        Type.purchase_order,
        Type.purchase_goods_received_note,
        Type.purchase_credit_note,
    ],
    tags: [
        Type.sale_quote,
        Type.sale_delivery_order,
        Type.sale_order,
        Type.sale_invoice,
        Type.sale_payment,
        Type.sale_credit_note,
        Type.sale_refund,
        Type.purchase_order,
        Type.purchase_goods_received_note,
        Type.purchase_bill,
        Type.purchase_credit_note,
        Type.purchase_payment,
        Type.purchase_refund,
        Type.bank_income,
        Type.bank_expense,
        Type.bank_transfer,
        Type.journal_entry,
        Type.contra,
        Type.tax_deemed_payment,
    ],
    showShipping: [
        Type.sale_quote,
        Type.sale_delivery_order,
        Type.sale_order,
        Type.sale_invoice,
        Type.sale_credit_note,
        Type.purchase_order,
        Type.purchase_goods_received_note,
        Type.purchase_bill,
        Type.purchase_credit_note,
    ],

};

export function getSpecs(transactionType) {
    const spec = {};

    Object
        .keys(SpecInfo)
        .forEach(key => {
            spec[key] = (SpecInfo[key] || []).includes(transactionType);
        });

    return spec;
}
